const getGlobal = (state) => state.global;

export const getIsLoading = (state) => getGlobal(state).loading;
export const getLoadingMessage = (state) => getGlobal(state).message;
